import {
  AlumnoPractica,
  CursoPractica,
  ExportExcelData,
  FechaMaximaPractica,
  FechaMinimaPractica,
  RequestErrorMessagePayload,
} from 'store/practicas/types';
import { DatosPerfilesUsuario } from '../store/usuarios/types';
import { LiteralHeadersTableTitles } from '../consts';
import { parseDate, parsePracticeStatus, parseTime } from './parsePractices';
import { exportDataTableExcel } from './export-excel';

const estadoPCConstant = 'Pendiente de Corrección';
const estadoPVConstant = 'Pendiente de Validar';

export const parseMinDatePractice = (
  dateMin: FechaMinimaPractica | RequestErrorMessagePayload
): FechaMinimaPractica => {
  if (
    'MENSAJE' in dateMin ||
    ('FECHA_DATE' in dateMin && !dateMin.FECHA_DATE)
  ) {
    const calculateDate = calculateDefaultMinDate();
    return {
      FECHA_DATE: dateToStringDateFormatted(calculateDate),
      FECHA_TIMESTAMP: calculateDate.getTime(),
    };
  }
  return dateMin;
};

export const parseMaxDatePractice = (
  dateMax: FechaMaximaPractica | RequestErrorMessagePayload
): FechaMaximaPractica => {
  if (
    'MENSAJE' in dateMax ||
    ('FECHA_DATE' in dateMax && !dateMax.FECHA_DATE)
  ) {
    const calculateDate = calculateDefaultMaxDate();
    return {
      FECHA_DATE: dateToStringDateFormatted(calculateDate),
      FECHA_TIMESTAMP: calculateDate.getTime(),
    };
  }
  return dateMax;
};

export const calculateDefaultMaxDate = (): Date => {
  const date = new Date();
  date.setHours(23, 59, 59, 999);
  return date;
};

export const calculateDefaultMinDate = (): Date => {
  const date = new Date();
  date.setMonth(date.getMonth() - 1);
  date.setHours(23, 59,59,999);
  return date;
};

export const dateToStringDateFormatted = (date: Date): string => {
  return `${date.getDate()}-${date.getMonth()}-${date.getFullYear()}`;
};

export const getDefaultPracticeState = (
  profileActive: DatosPerfilesUsuario,
  initFilter
): string => {
  let defaultStatus: any[] = [];

  if (initFilter.savedValues === false || initFilter.estados === '') {
    if (!initFilter.alumnos || !initFilter.cursos) {
      if (
        profileActive?.ID_PERFIL === '111' ||
        profileActive?.ID_PERFIL === '112' ||
        profileActive?.ID_PERFIL === '121' ||
        profileActive?.ID_PERFIL === '122' ||
        profileActive?.ID_PERFIL === '123'
      ) {
        defaultStatus = [
          { label: 'Borrador', value: 'BO' },
          { label: estadoPCConstant, value: 'PC' },
        ];
      } else {
        defaultStatus = [
          { label: estadoPVConstant, value: 'PV' },
          { label: 'Reclamada', value: 'RE' },
        ];
      }
    } else {
      defaultStatus = [
        { label: estadoPVConstant, value: 'PV' },
        { label: 'Reclamada', value: 'RE' },
        { label: 'Borrador', value: 'BO' },
        { label: estadoPCConstant, value: 'PC' },
        { label: 'Anulada', value: 'AN' },
        { label: 'Validada', value: 'VA' },
      ];
    }
  } else {
    const savedStatuses = initFilter.estados.split(',');
    savedStatuses.forEach((element) => {
      switch (element) {
        case 'PV':
          defaultStatus.push({ label: estadoPVConstant, value: 'PV' });
          break;
        case 'RE':
          defaultStatus.push({ label: 'Reclamada', value: 'RE' });
          break;
        case 'BO':
          defaultStatus.push({ label: 'Borrador', value: 'BO' });
          break;
        case 'PC':
          defaultStatus.push({ label: estadoPCConstant, value: 'PC' });
          break;
        case 'AN':
          defaultStatus.push({ label: 'Anulada', value: 'AN' });
          break;
        case 'VA':
          defaultStatus.push({ label: 'Validada', value: 'VA' });
          break;
      }
    });
  }

  return JSON.stringify(defaultStatus);
};

export const parseSelectedCourses = (
  selectedCourses: number[],
  courses: CursoPractica[]
): string => {
  const filteredCourses = courses.filter((course: CursoPractica) =>
    selectedCourses.includes(course.ID_CURSO)
  );
  const mappedValue = filteredCourses.map((course: CursoPractica) => ({
    label: `${course?.ID_CURSO} - ${course.NOMBRE_CURSO}`,
    value: course,
  }));
  return mappedValue.length ? JSON.stringify(mappedValue) : '[]';
};

export const parseSelectedStudent = (
  selectedStudents: string[],
  students: AlumnoPractica[]
): string => {
  const filteredStudents = students.filter((student: AlumnoPractica) =>
    selectedStudents.includes(student.ID_ALUMNO)
  );
  const mappedStudents: any[] = filteredStudents.map(
    (student: AlumnoPractica): any => ({
      label: `${student.ID_ALUMNO} - ${student.NOMBRE_ALUMNO}`,
      value: student,
    })
  );
  return mappedStudents.length ? JSON.stringify(mappedStudents) : '[]';
};

export const exportToExcel = async (
  practices,
  profileActive,
  literalsHeaderTable,
  infoUser,
  titleInfo
) => {
  if (practices) {
    if (profileActive) {
      // TODO: Parse service data to send it to the export excel library
      const EXPORT_EXCEL: ExportExcelData = {
        headerExcelFile: [],
        bodyExcelFile: [],
        headerColumsConfig: [],
        title: titleInfo + new Date().getTime().toString(),
      };

      literalsHeaderTable.forEach((item) => {
        if (item.text === LiteralHeadersTableTitles.RUTA) {
          EXPORT_EXCEL.headerExcelFile.push(
            LiteralHeadersTableTitles.ESTACION_INICIO
          );
          EXPORT_EXCEL.headerColumsConfig.push({
            label: LiteralHeadersTableTitles.ESTACION_INICIO,
            key: LiteralHeadersTableTitles.ESTACION_INICIO,
            width: 30,
          });

          EXPORT_EXCEL.headerExcelFile.push(
            LiteralHeadersTableTitles.ESTACION_FIN
          );
          EXPORT_EXCEL.headerColumsConfig.push({
            label: LiteralHeadersTableTitles.ESTACION_FIN,
            key: LiteralHeadersTableTitles.ESTACION_FIN,
            width: 30,
          });
        } else if (item.text === LiteralHeadersTableTitles.TREN) {
          EXPORT_EXCEL.headerExcelFile.push(LiteralHeadersTableTitles.TREN);
          EXPORT_EXCEL.headerColumsConfig.push({
            label: LiteralHeadersTableTitles.TREN,
            key: LiteralHeadersTableTitles.TREN,
            width: 30,
          });

          EXPORT_EXCEL.headerExcelFile.push(LiteralHeadersTableTitles.VEHICULO);
          EXPORT_EXCEL.headerColumsConfig.push({
            label: LiteralHeadersTableTitles.VEHICULO,
            key: LiteralHeadersTableTitles.VEHICULO,
            width: 30,
          });

          EXPORT_EXCEL.headerExcelFile.push(LiteralHeadersTableTitles.TURNO);
          EXPORT_EXCEL.headerColumsConfig.push({
            label: LiteralHeadersTableTitles.TURNO,
            key: LiteralHeadersTableTitles.TURNO,
            width: 30,
          });
          EXPORT_EXCEL.headerExcelFile.push(LiteralHeadersTableTitles.ID_ALUMNO);
          EXPORT_EXCEL.headerColumsConfig.push({
            label: LiteralHeadersTableTitles.TURNO,
            key: LiteralHeadersTableTitles.TURNO,
            width: 30,
          });
          EXPORT_EXCEL.headerExcelFile.push(LiteralHeadersTableTitles.ALUMNO_NOMBRE);
          EXPORT_EXCEL.headerColumsConfig.push({
            label: LiteralHeadersTableTitles.TURNO,
            key: LiteralHeadersTableTitles.TURNO,
            width: 30,
          });
          EXPORT_EXCEL.headerExcelFile.push(LiteralHeadersTableTitles.ID_INSTRUCTOR);
          EXPORT_EXCEL.headerColumsConfig.push({
            label: LiteralHeadersTableTitles.TURNO,
            key: LiteralHeadersTableTitles.TURNO,
            width: 30,
          });
          EXPORT_EXCEL.headerExcelFile.push(LiteralHeadersTableTitles.INSTRUCTOR_NOMBRE);
          EXPORT_EXCEL.headerColumsConfig.push({
            label: LiteralHeadersTableTitles.TURNO,
            key: LiteralHeadersTableTitles.TURNO,
            width: 30,
          });
        } else {
          EXPORT_EXCEL.headerExcelFile.push(item.text);
          EXPORT_EXCEL.headerColumsConfig.push({
            label: item.text,
            key: item.text,
            width: 30,
          });
        }
      });
      EXPORT_EXCEL.headerExcelFile.pop();
      EXPORT_EXCEL.headerColumsConfig.pop();
      let itemArray: any = [];
      if (
        profileActive?.ID_PERFIL === '111' ||
        profileActive?.ID_PERFIL === '112' ||
        profileActive?.ID_PERFIL === '121' ||
        profileActive?.ID_PERFIL === '122' ||
        profileActive?.ID_PERFIL === '123'
      ) {
        practices.forEach((element: any) => {
          itemArray = [];
          itemArray.push(
            element.ID_CURSO,
            parseDate(element.FECHA_INI_SERVICIO) +
            ' ' +
            parseTime(element.HORA_INI_SERVICIO),
            parseDate(element.FECHA_FIN_SERVICIO) +
            ' ' +
            parseTime(element.HORA_FIN_SERVICIO),
            element.MIN_PRACTICA,
            element.DESC_PRACTICA,
            element.NUM_TREN,
            parsePracticeStatus(element.ID_EST_PRACTICA)
          );
          EXPORT_EXCEL.bodyExcelFile.push(itemArray);
        });
      } else {
        practices.forEach((element: any, index: any) => {
          itemArray = [];
          const observations = getObservations(element);
          itemArray.push(
            element.ID_CURSO,
            parseDate(element.FECHA_INI_SERVICIO) +
            ' ' +
            parseTime(element.HORA_INI_SERVICIO),
            parseDate(element.FECHA_FIN_SERVICIO) +
            ' ' +
            parseTime(element.HORA_FIN_SERVICIO),
            element.MIN_PRACTICA,
            element.DESC_PRACTICA,
            element.COD_ESTACION_INI + ' - ' + element.DESC_ESTACION_INI,
            element.COD_ESTACION_FIN + ' - ' + element.DESC_ESTACION_FIN,
            element.NUM_TREN,
            element.VEHICULO,
            element.NUM_TURNO,
            infoUser[index] ? element.ID_ALUMNO : '',
            infoUser[index] ? infoUser[index]['NOMBRE_USUARIO'] : '',
            element.ID_INSTRUCTOR,
            element.NOMBRE_INSTRUCTOR,
            (profileActive?.ID_PERFIL === '511' ||
              profileActive?.ID_PERFIL === '311' ||
              profileActive?.ID_PERFIL === '411' ||
              profileActive?.ID_PERFIL === '611' ||
              profileActive?.ID_PERFIL === '711') &&
            element.jornadaRelacionada &&
            `${parseDate(
              element.jornadaRelacionada[0].FECHA_INI_JORNADA
            )} - ${parseTime(
              element.jornadaRelacionada[0].HORA_INI_JORNADA
            )} / ${parseDate(
              element.jornadaRelacionada[0].FECHA_FIN_JORNADA
            )} - ${parseTime(
              element.jornadaRelacionada[0].HORA_FIN_JORNADA
            )} - ${observations} - ${element.MIN_PUESTA_DISP
            } minutos puesta a disposición`,

            parsePracticeStatus(element.ID_EST_PRACTICA)
          );
          EXPORT_EXCEL.bodyExcelFile.push(itemArray);
        });
      }

      exportDataTableExcel(
        EXPORT_EXCEL.headerExcelFile,
        EXPORT_EXCEL.bodyExcelFile,
        EXPORT_EXCEL.headerColumsConfig,
        EXPORT_EXCEL.title
      );
    }
  }
};

export const getDefaultStatus = (profileActive, initFilter) => {
  let newInitFilter = { ...initFilter };

  if (!newInitFilter.alumnos || !newInitFilter.cursos) {
    if (
      profileActive?.ID_PERFIL === '111' ||
      profileActive?.ID_PERFIL === '112' ||
      profileActive?.ID_PERFIL === '121' ||
      profileActive?.ID_PERFIL === '122' ||
      profileActive?.ID_PERFIL === '123'
    ) {
      newInitFilter = { ...initFilter, estados: 'BO,PC' };
    } else {
      newInitFilter = { ...initFilter/* , estados: 'PV,RE' */ };
    }
  }

  return newInitFilter;
};

export const addSingleQuotesToStudentsDniChain = (
  studentsDniChain: string
): string => {
  const studentsDni: string[] = studentsDniChain.split(',');
  const firstValue: string = studentsDni[0];

  if (studentsDni.length === 1) {
    return firstValue;
  }

  const newStudentsDniChain = studentsDni.map((item) => item).join(',');

  return newStudentsDniChain;
};

export const responseMessage = (data: any, bodyMessage: string) => {
  let message = `${bodyMessage}`;

  if (data?.STATUS_OK.length === 1 && data?.MESSAGE_ERROR_SMS) {
    message += `, ${data?.MESSAGE_ERROR_SMS[0].ERROR_SMS}`;
  }

  return message;
};

// Format 1 h. 2 min.
export const formatMinutes = (minutes: number) => {
  const minuteTime = minutes;
  let hourTime = 0;
  let result: string;
  if (minuteTime >= 60) {
    hourTime = parseInt((minuteTime / 60).toString());
    const formatMinuteTime = `${minuteTime % 60}`;
    result =
      formatMinuteTime === '0'
        ? `${hourTime} h.`
        : `${hourTime} h. ${formatMinuteTime} min.`;
  } else if (minuteTime < 0) {
    result = '0h';
  } else {
    result = minuteTime === 0 ? '0h' : `0 h. ${minuteTime} min.`;
  }

  return result;
};

export const formatMinutesExcel = (minutes: number) =>
  parseFloat((minutes / 60).toFixed(2));

export const getObservations = (element: any) => {
  const hasAlumnAndInstructorObservations =
    element.OBSERVACIONES_ALUMNO !== null &&
    element.OBSERVACIONES_INSTRUCTOR !== null;
  const hasOnlyInstructorObservations =
    element.OBSERVACIONES_INSTRUCTOR !== null &&
    element.OBSERVACIONES_ALUMNO === null;
  const hasOnlyAlumnObservations =
    element.OBSERVACIONES_INSTRUCTOR === null &&
    element.OBSERVACIONES_ALUMNO !== null;

  let observations = 'No hay observaciones';

  switch (true) {
    case hasAlumnAndInstructorObservations:
      observations = `${element.OBSERVACIONES_ALUMNO} / ${element.OBSERVACIONES_INSTRUCTOR}`;
      break;

    case hasOnlyInstructorObservations:
      observations = `No hay observaciones del alumno / ${element.OBSERVACIONES_INSTRUCTOR}`;
      break;

    case hasOnlyAlumnObservations:
      observations = `${element.OBSERVACIONES_ALUMNO} / No hay observaciones del instructor`;
      break;

    default:
      break;
  }
  return observations;
};

/** Format informs with  > 480 ->
 * (TBGFM008_JORNADA.MIN_CONDUCCION_EFECT + TBGFM008_JORNADA.MIN_PV_EFECT - TBGFM008_JORNADA.MIN_PV_OTROS)
 */
export const formatOtherPractices = (
  fechaInicio: number,
  fechaFin: number,
  minutos_conduccionEfectiva: number = 0,
  minutos_pv_efectiva: number = 0,
  minutos_pv_otros: number = 0
): string => {
  const minutesTotal = (fechaFin - fechaInicio) / 60000;

  let result: number = 0;
  const sumaMinutesEfect = minutos_conduccionEfectiva + minutos_pv_efectiva;
  if (minutesTotal >= 480) {
    if (sumaMinutesEfect < minutos_pv_otros) {
      result = 480 - minutos_pv_otros;
    } else {
      result =
        480 -
        (minutos_conduccionEfectiva + minutos_pv_efectiva - minutos_pv_otros);
    }
  } else {
    result =
      sumaMinutesEfect < minutos_pv_otros
        ? minutesTotal - minutos_pv_otros
        : minutesTotal -
        (minutos_conduccionEfectiva + minutos_pv_efectiva - minutos_pv_otros);
  }
  return formatMinutes(result);
};
/**
 * Elimina la paginación guardada y cambia el número de página actual.
 * @param urlFrom - La URL de la página actual.
 * @param elemPage - Indica si el número de página actual es un elemento de página.
 */
export const paginationChangeNumber = (
  urlFrom: string = window.location.pathname,
  elemPage: boolean = true
) => {
  deleteSavedPagination(urlFrom, true, false, elemPage);
};

/**
 * Elimina la paginación guardada en sessionStorage para una URL específica.
 * @param urlFrom - La URL para la que se eliminará la paginación guardada. Por defecto, es la URL actual.
 * @param currentPage - Si se debe eliminar la página actual guardada. Por defecto, es verdadero.
 * @param removeFilters - Si se deben eliminar los filtros guardados. Por defecto, es falso.
 * @param elemPage - Si se deben eliminar los elementos por página guardados. Por defecto, es falso.
 */
export const deleteSavedPagination = (
  urlFrom: string = window.location.pathname,
  currentPage: boolean = true,
  removeFilters: boolean = false,
  elemPage: boolean = false
) => {
  const keys = Object.keys(sessionStorage);
  const url = currentPage ? `-${urlFrom}` : '';
  const filteredKeys = keys.filter(
    (key) =>
      key.includes(`pages${url}`) ||
      key.includes(`pageActive${url}`) ||
      key.includes(`pageSelected${url}`) ||
      (removeFilters && key.includes(`savedFilter${url}`)) ||
      ((elemPage || removeFilters) &&
        (key.includes(`elementsPerPage${url}`) ||
          key.includes(`pageSelected${url}`)))
  );
  filteredKeys.forEach((key) => sessionStorage.removeItem(key));
};
